// ##### Komarov 2025-07-18
import React from 'react';
// ##### 23-11-08 Komarov
import { Media } from '../../../../helpers/MediaConfig.js';
// ##### 25-05-21 Komarov
import HotelsPaxChoiceWrapperPageDevices from './HotelsPaxChoiceWrapperPageDevices.jsx';

// ##### Komarov 2025-07-18
const HotelsPaxChoicePageDevices = ({
  isSecondSearch,
}) => {
  return (
    <>
      {/* ##### 23-11-08 Komarov */}
      <Media greaterThanOrEqual="Laptop-1024-1440">
        <HotelsPaxChoiceWrapperPageDevices />
      </Media>
      {/* ##### 23-11-15 Komarov */}
      <Media at="Tablet-768-1024">
        <HotelsPaxChoiceWrapperPageDevices
          // width='100%'
          width="35vw"
          isSecondSearch={isSecondSearch}
        />
      </Media>
      <Media lessThan="Tablet-768-1024">
        <HotelsPaxChoiceWrapperPageDevices
          // ##### 23-11-15 Komarov
          // width='100%'
          width="78vw"
          isSecondSearch={isSecondSearch}
        />
      </Media>
    </>
  );
};

// ##### 25-05-21 Komarov
export default HotelsPaxChoicePageDevices;
